const Footer = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: 10,
      }}
    >
      Made with {" "}
      <a
        href="#"
        style={{ cursor: "pointer" }}
      >
        ♥
      </a>
    </div>
  );
};

export default Footer;
